<template>
  <Card>
    <template #title>
      <Toolbar>
        <template #left>
          <div class="p-card-title">Documentation</div>
        </template>
      </Toolbar>
    </template>

    <template #content>
      <DataTable
        ref="dt"
        responsiveLayout="scroll"
        class="p-datatable-sm"
        filterDisplay="row"
        sortMode="multiple"
        removableSort
        stateStorage="local"
        :stateKey="stateKey"
        :value="dataModel"
        :loading="!dataModel || loading"
        :paginator="true"
        :rows="pageSize"
        :lazy="true"
        v-model:first="start"
        v-model:filters="filters"
        :totalRecords="totalRecords"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        @state-restore="onStateRestore($event)"
        @page="onPage($event)"
        @sort="onSort($event)"
        @filter="onFilter($event)"
        dataKey="Id"
      >
        <!-- Action Column -->
        <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
          <template #filter>
            <Button
              :label="$t('clear')"
              icon="pi pi-filter-slash"
              class="p-button-outlined p-button-primary p-button-sm"
              @click="clearFilter"
              :badge="filterBadge"
              badgeClass="p-badge-danger"
            />
          </template>
          <template #body="slotProps">
            <p class="center">{{ slotProps.index + 1 }}</p>
          </template>
        </Column>

        <Column field="Category" :header="$t('Category')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('Category')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>

        <Column field="Document_Name" :header="$t('Document_Name')" :sortable="true">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              :placeholder="$t('Document_Name')"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column header="File" headerStyle="white-space:nowrap">
        <template #body="slotProps">
            <Button 
            icon="pi pi-download"
            v-if="slotProps.data.Id" 
            class="p-button-rounded p-button-info mr-2 p-button-sm"
            @click="downloadFile(slotProps.data.Id)" 
            />
        </template>
        </Column>
       
      </DataTable>
    </template>
  </Card>
</template>

<script>
import IndexBase from "../Helper/IndexBase.vue";

export default {
  name: "GeneralInformationDocumentation",
  components: {
    IndexBase,
  },
  data() {
    return {
      dataModel: null,
      loading: true,
      totalRecords: 0,
      start: 0,
      stateKey: this.$STATE_NAME + "generalInformationDocumentation-" + this.$store.getters.getUsername,
      sorts: null,
      lazyParams: {},
      filters: null,
      stateFilters: null,
      dataUrl: "GeneralInformation/Documentation",
      pageSize: 10,
    };
  },
  methods: {
    onPage(event) {
      this.start = event.first;
      this.pageSize = event.rows;
      this.loadLazyData();
    },
    onSort(event) {
      this.sorts = event.multiSortMeta;
      this.loadLazyData();
    },
    onFilter() {
      this.loadLazyData();
    },
    loadLazyData() {
      this.loading = true;
      this.selectedRow = null;

      this.lazyParams = {
         ...this.$route.query,
        start: this.start,
        pageSize: this.pageSize,
        sorts: this.dataSort,
        filters: this.dataFilter,
      };

      var self = this;

      this.$axios
        .post(this.$API_URL + this.dataUrl, this.lazyParams)
        .then((response) => {
          if (response.data.success) {
            this.dataModel = response.data.data;
            this.totalRecords = response.data.totalRecords;
          } else {
            self.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: this.$DEFAULT_TIMER,
            });
          }
          this.loading = false;
        })
        .catch(function (err) {
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: this.$DEFAULT_TIMER,
          });
          self.loading = false;
        });
    },
downloadFile(Id) {
  const url = this.$API_URL + "GeneralInformation/DownloadDoc/" + Id;

  this.$axios.get(url, {
    responseType: "blob",
    timeout: this.$AXIOS_TIMEOUT_LONG
  })
  .then(response => {
    let fileName = "download.bin";
    const disposition = response.headers["content-disposition"];
    if (disposition && disposition.includes("filename=")) {
      fileName = disposition.split("filename=")[1].replace(/"/g, "");
    }
    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link.href);
  })
  .catch(err => {
    console.error("Download failed", err);
  });
},
    setFilters() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var filterValue = null;
        if (this.stateFilters) {
          var field = this.stateFilters[exportable[i].props.field];
          if (field) filterValue = field.value;
        }
        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }
    },
    onStateRestore(event) {
      this.start = event.first;
      this.pageSize = event.rows;
      this.stateFilters = event.filters;
      this.sorts = event.multiSortMeta;
    },
    clearFilter() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var fieldName = exportable[i].props.field;
        var filterValue = "";
        if (fieldName.includes("Date")) {
          filterValue = null;
        }
        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }
      this.sorts = null;
      this.loadLazyData();
    },
  },
  mounted() {
    this.$emit("unblock-ui");
    this.setFilters();
    this.loadLazyData();
    this.$showToast();
  },
  computed: {
    dataFilter() {
      var h = [];
      if (this.filters) {
        for (const [key, value] of Object.entries(this.filters)) {
          h.push({
            field: key ? key : null,
            value: value.value,
            matchMode: value.matchMode,
          });
        }
      }
      return h;
    },
    dataSort() {
      var h = [];
      if (this.sorts) {
        for (var x = 0; x < this.sorts.length; x++) {
          h.push({
            field: this.sorts[x].field,
            order: this.sorts[x].order == 1 ? "ASC" : "DESC",
          });
        }
      }
      return h;
    },
    filterBadge() {
      var badgeNumber = 0;
      this.dataFilter.filter(function (item) {
        if (item.value && item.field != "Status") {
          badgeNumber++;
        }
      });
      return badgeNumber;
    },
  },
};
</script>

<style scoped>
.p-card .p-card-content {
  margin: 0 !important;
  padding: 0 !important;
}
</style>